import type { MRT_ColumnDef } from "mantine-react-table-open";
import { SiteCategory } from "../../site-status-types";
import type { SiteOverviewSite, SiteStatusSite } from "../../site-status-types";

function getClassificationColumn(): MRT_ColumnDef<
  SiteOverviewSite | SiteStatusSite
> {
  return {
    header: "Klassifizierung",
    accessorFn: (rowData) => rowData.siteCategories,
    maxSize: 150,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: Object.values(SiteCategory)
    },
    Cell: ({ cell }) => cell.getValue<Array<SiteCategory>>().join(", "),
    enableGlobalFilter: false
  };
}

export { getClassificationColumn };
